import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../openapi";
import { IRootState } from "./app/store";

export const selectHttpCurrentUser = createSelector([(state: IRootState) => state], (state) => {
  const result = openapi.endpoints.getAuthMe.select(undefined)(state);
  return result.data ?? null;
});
const ADMINS = [
  "perst@multiconsult.no",
  "johnnie.gallon@multiconsult.no",
  "per.strom@multiconsult.no",
  "oskl@multiconsult.no",
  "oskar.lindgren@multiconsult.no",
];

export const selectIsSystemAdmin = createSelector([selectHttpCurrentUser], (user) => {
  if (!user || !user.email) {
    return false;
  }

  return ADMINS.includes(user.email);
});

export const selectIsExternalUser = createSelector([selectHttpCurrentUser], (user) => {
  if (!user) {
    return false;
  }
  return user.isExternal;
});
